<div class="product-detail-channels-background intro-background" [ngStyle]="{ 'background-image': 'url(' + backgroundImageUrl + ')'}">
  <div ngClass="isOmapiBETVSport() ? product-detail-offer-body : product-detail-offer-body-600">
    <div class="left">
      <h3 class="product-detail-channels-title" [translate]="titleKey"></h3>
      <div class="product-detail-channels-text intro-text" [innerHTML]="descriptionKey | translate"></div>
      <app-order-button [x]="0"
                        [y]="0"
                        [pack]="pack"
                        [subPack]="subPack"
                        (emitOnEnterPressed)="onEmitOrderProduct($event)"
                        [ownerComponent]="componentName"
                        (emitOnBack)="onBack()"
      ></app-order-button>
      <p [translate]="belowOrderTextKey"></p>
    </div>
    <div class="product-detail-channels-image-holder right" *ngIf="showBannerImage">
      <img class="product-detail-channels-image" ngClass="" src="{{bannerImageUrl}}"/>
    </div>
  </div>
</div>
